import {
  UPDATE_ANNUAL_INCOME,
  UPDATE_OCCUPATION,
  UPDATE_POLITICALLY_EXPOSED,
  UPDATE_REKYC_MODAL_STATE,
  UPDATE_RESTRICTION_INFO_MODAL,
  actionTypes,
} from 'actionTypes/rekycVerification';
import { REKYC_API } from 'constants/api';
import createAction from 'helpers/createAction';
import { RekycFaceAuthEnrollPayload } from 'types/RekycVerification';

import { authAction } from './user';

const updateOccupation = createAction<{ value: string }>(UPDATE_OCCUPATION);

const updateAnnualIncome = createAction<{ value: string }>(UPDATE_ANNUAL_INCOME);

const updateIsPoliticallyExposed = createAction<{ value: boolean }>(
  UPDATE_POLITICALLY_EXPOSED
);

const updateModalState = createAction<{ value: boolean; source?: string }>(
  UPDATE_REKYC_MODAL_STATE
);

const getProfileKycDetails = () => {
  return authAction({
    types: actionTypes['REKYC/GET_PROFILE_KYC_DETAILS'],
    promise: ({ request }) => request.get(REKYC_API.GET_PROFILE_KYC_DETAILS),
  });
};

const faceAuthEnroll = ({ data }: RekycFaceAuthEnrollPayload) => {
  return authAction({
    types: actionTypes['REKYC/FACE_AUTH_ENROLL'],
    promise: ({ request }) => request.post(REKYC_API.FACE_AUTH_ENROLL, { data }),
  });
};

const updateAddressConfig = () => {
  return authAction({
    types: actionTypes['REKYC/UPDATE_ADDRESS_CONFIG'],
    promise: ({ request }) => request.post(REKYC_API.UPDATE_ADDRESS_CONFIG),
  });
};

const getRekycFlow = () => {
  return authAction({
    types: actionTypes['REKYC/GET_REKYC_FLOW'],
    promise: ({ request }) => request.get(REKYC_API.GET_REKYC_FLOW),
  });
};

const updateKycInfoPendingModal = createAction<{ value: boolean }>(
  UPDATE_RESTRICTION_INFO_MODAL
);

export {
  updateOccupation,
  updateAnnualIncome,
  updateIsPoliticallyExposed,
  getProfileKycDetails,
  faceAuthEnroll,
  updateKycInfoPendingModal,
  updateAddressConfig,
  updateModalState,
  getRekycFlow,
};
